import { Link, Typography } from "@material-ui/core"
import * as api from "api"
import Image from "next/image"
import styled from "styled-components"

const StyledContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  img {
    border-radius: 50%;
  }
`
const StyledSmallText = styled(Typography).attrs({ variant: "body2" })<{
  $bold?: boolean
}>`
  font-weight: ${(p) => (p.$bold ? "bold" : "300")};
`
const StyledLink = styled(Link)`
  color: ${(p) => p.theme.colors.saphire} !important;
  text-decoration: underline;
  cursor: pointer;
  p {
    color: ${(p) => p.theme.colors.saphire} !important;
  }
`

type ManagerBoxProps = {
  showRoom: api.ShowRoom
}

const ManagerBox = ({ showRoom }: ManagerBoxProps) => {
  return (
    <>
      {showRoom?.managerName && showRoom?.managerEmail && (
        <StyledContent>
          <Image
            src={
              showRoom.managerImage
                ? showRoom.managerImage.imageUrl
                : "/img/managerPlaceholder.png"
            }
            alt={showRoom.managerImage ? showRoom.managerImage.alt : "manager"}
            width={50}
            height={50}
            objectFit="cover"
            priority
          />
          <div>
            {showRoom?.managerName && (
              <StyledSmallText>{showRoom?.managerName}</StyledSmallText>
            )}
            {showRoom.managerEmail && (
              <StyledLink href={`mailto:${showRoom.managerEmail}`}>
                <StyledSmallText>{showRoom?.managerEmail}</StyledSmallText>
              </StyledLink>
            )}
          </div>
        </StyledContent>
      )}
    </>
  )
}

export default ManagerBox
